import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoA, LogoB, LogoC, LogoD, LogoE, Lockup } from "@/components/logo/Proposals";

const PROPOSALS = [
  { id: "A", name: "Sigillo", desc: "Monogramma in doppio anello con legenda curva: autorevolezza da casa medice, perfetto per contratti e flussi ufficiali.", Logo: LogoA },
  { id: "B", name: "Meridiani", desc: "Il globo con i meridiani incornicia le iniziali: il mondo è il tuo mercato, al centro il tuo nome.", Logo: LogoB },
  { id: "C", name: "Rotta", desc: "Monogramma sopra una rotta tratteggiata in ascesa con freccia: movimento, export, crescita.", Logo: LogoC },
  { id: "D", name: "Bussola", desc: "Esagono da marca da spedizione con ago della bussola: orientamento nel commercio internazionale.", Logo: LogoD },
  { id: "E", name: "Editoriale", desc: "Telaio tipografico con rombo dorato: l'eleganza sobria di uno studio professionale.", Logo: LogoE },
];

export default function LogoProposals() {
  return (
    <div className="min-h-screen bg-navy px-6 pb-24 pt-16 noise lg:px-10">
      <div className="mx-auto max-w-6xl">
        <Link to="/" data-testid="logo-back-home" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-gold transition-colors hover:text-gold-bright">
          <ArrowLeft className="h-4 w-4" /> Torna al sito
        </Link>
        <h1 className="mt-8 font-serif text-4xl text-ivory sm:text-5xl">Proposte logo — LB Trade Advisory</h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-ivory/55">
          Cinque alternative nei colori del brand (blu notte, oro, avorio). Per ciascuna: il simbolo grande, la versione completa come apparirebbe nella barra di navigazione, e il simbolo in formato favicon su sfondo scuro e chiaro.
        </p>

        <div className="mt-14 space-y-10">
          {PROPOSALS.map(({ id, name, desc, Logo }) => (
            <div key={id} className="border border-gold/20 bg-navy-light/60 p-8" data-testid={`logo-proposal-${id.toLowerCase()}`}>
              <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
                <span className="font-mono text-xs tracking-[0.3em] text-gold">PROPOSTA {id}</span>
                <h2 className="font-serif text-2xl text-ivory">{name}</h2>
              </div>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ivory/55">{desc}</p>

              <div className="mt-7 grid items-center gap-6 lg:grid-cols-[110px_1fr_260px]">
                <div className="flex h-[130px] items-center justify-center border border-gold/15 bg-navy">
                  <Logo size={100} bg="dark" />
                </div>
                <div className="flex h-[110px] items-center justify-center border border-gold/15 bg-navy">
                  <Lockup Logo={Logo} compactSize={34} bg="dark" />
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="flex h-20 items-center justify-center border border-gold/15 bg-navy">
                    <Logo size={26} bg="dark" />
                  </div>
                  <div className="flex h-20 items-center justify-center border border-ivory/10 bg-ivory">
                    <Logo size={26} bg="light" />
                  </div>
                  <div className="flex h-20 items-center justify-center border border-gold/15 bg-navy-light">
                    <Logo size={26} bg="dark" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-12 border-t border-gold/15 pt-6 text-sm text-ivory/50" data-testid="logo-proposals-note">
          Scegli la proposta che preferisci: aggiornerò logo nella barra di navigazione, nel footer, nel pannello admin e la favicon del browser.
        </p>
      </div>
    </div>
  );
}
